export const sidebarConstants = {
  UPDATE_STATUS: "UPDATE_STATUS",
  INIT_NUMBERS: "INIT_NUMBERS",
  UPDATE_SELECTIONS: "UPDATE_SELECTIONS",
  RESET_FILTER: "RESET_FILTER",
};
